import React from 'react';
import 'whatwg-fetch';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';

import ModalConfirm from '../modal/modalConfirm';

export default class DatePickerUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isPropsReceived: false,
      isBlackOut: false,
      onUpdate: false,
      inputLabel: this.props.inputLabel ? this.props.inputLabel : null,
      inputValue: this.props.inputValue,
      inputValueSaved: this.props.inputValue,
      isModalConfirmOpen: false,
      textModal: {
        title: 'Confirmer modification',
        message: this.props.inputLabel
          ? 'Vous allez modifier "' + this.props.inputLabel + '"'
          : 'Vous allez modifier le champ',
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openConfirmModal = this.openConfirmModal.bind(this);
    this.onUpdate = this.onUpdate.bind(this);
    this.cancelUpdate = this.cancelUpdate.bind(this);
    this.submitUpdate = this.submitUpdate.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      inputValue: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.onUpdate && nextProps.inputValue != this.props.inputValue) {
      // init or parent's routing with updated props.match.id
      this.setState({
        isPropsReceived: true,
        inputValue: nextProps.inputValue,
        inputValueSaved: nextProps.inputValue,
      });
    }
  }

  render() {
    return (
      <div className='form-group'>
        {this.state.inputLabel && <label>{this.state.inputLabel}</label>}
        <div className='alignHorizontal'>
          {this.state.onUpdate ? (
            <DatePicker
              calendarContainer={this}
              name='inputValue'
              value={this.state.inputValue}
              onChange={this.handleDateChange}
              dateFormat='YYYY-MM-DD'
            />
          ) : (
            <input
              name='inputValue'
              value={moment(this.state.inputValue).format('DD-MM-YY')}
              onChange={this.handleInputChange}
              type='text'
              className='form-control'
              readOnly
            />
          )}

          {this.state.onUpdate ? (
            <div className='alignHorizontal'>
              <button onClick={() => this.openConfirmModal()} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-check'></span>
              </button>
              <button onClick={() => this.cancelUpdate()} type='button' className='btn btn-sm btn-outline-success'>
                <span className='icon icon-back'></span>
              </button>
            </div>
          ) : (
            <button onClick={() => this.onUpdate()} type='button' className='btn btn-sm btn-outline-success'>
              <span className='icon icon-brush'></span>
            </button>
          )}
        </div>

        <ModalConfirm
          className='myModal'
          modalText={this.state.textModal}
          isOpen={this.state.isModalConfirmOpen}
          onSubmit={() => this.submitUpdate()}
          onClose={() => this.closeModal()}
          onCancel={() => this.closeModal()}
        ></ModalConfirm>
      </div>
    );
  }

  closeModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalConfirmOpen: false,
    });
  }

  openConfirmModal() {
    this.props.toggleBlackOut();
    this.setState({
      isModalConfirmOpen: true,
    });
  }

  onUpdate() {
    this.setState({
      inputValueSaved: this.state.inputValue,
      onUpdate: true,
    });
  }

  cancelUpdate() {
    this.setState({
      inputValue: this.state.inputValueSaved,
      onUpdate: false,
    });
  }

  submitUpdate() {
    this.setState({
      onUpdate: false,
    });
    this.props.submitUpdate(this.state.inputValue, this.props.inputType);
  }
}
